import { NgModule } from "@angular/core";
import { CircCommonModule } from "../common/common.module";
import { DetailsComponent } from "./details/details.component";
import { EditMetadataComponent } from "./edit-metadata/edit-metadata.component";
import { EditStepComponent } from "./edit-step/edit-step.component";
import { EditTemplateComponent } from "./edit/edit.component";
import { BasicMetaDataComponent } from "./metadata/basic/basic.component";
import { MyTemplatesComponent } from "./my-templates/my-templates.component";
import { NewMetadataComponent } from "./new-metadata/new-metadata.component";
import { NewStepComponent } from "./new-step/new-step.component";
import { NewComponent } from "./new/new.component";
import { TemplatesRoutingModule } from "./templates-routing.module";

@NgModule({
  declarations: [
    NewComponent,
    DetailsComponent,
    NewStepComponent,
    EditStepComponent,
    EditTemplateComponent,
    MyTemplatesComponent,
    NewMetadataComponent,
    EditMetadataComponent,
    BasicMetaDataComponent
  ],
  imports: [CircCommonModule, TemplatesRoutingModule]
})
export class TemplatesModule {}
